import React from 'react';
import '../../assets/css/spinner.css';
import moment from 'moment';
import NoBudgetsMessage from './NoBudgetsMessage';
import { getWebBaseUrl } from '../../functions';

const SentBudgetsTable = (props) => {
  const truncateCell = {
    maxWidth: '25vw',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  const formatDate = (dateToFormat) =>
    moment(dateToFormat).format('DD/MM/YYYY');

  const formatUrl = (keyToUrl) => 
    (keyToUrl) ? getWebBaseUrl() + keyToUrl.replace('contracting-','?key=').replace('-','&code=') : "";

  if (!props.loading) {
     return props.rows.length > 0 ? (
      <div>
        <table className="table">
          <caption
            style={{ textAlign: 'center', paddingBottom: '15px' }}
            className="table__caption"
          >
            Presupuestos enviados
          </caption>
          <tbody>
            {props.rows.map((row, i) => (
              <tr key={i}>
                <td className="u-only-up-mobile">{i + 1}</td>
                <td className="u-font-bold">
                  {row.name} {row.surname}
                </td>
                <td title={row.product} style={truncateCell}>
                  {row.product}
                </td>
                <td title={row.email} style={truncateCell}>
                  {row.email}
                </td>
                <td className="u-font-bold">{formatDate(row.dateSent)}</td>
                {row.contractId ? (
                  <td
                    title={row.contractId}
                    className="icon icon--check u-brand-primary-color u-icon-size-normal" 
                    style={{textAlign: 'center'}}
                  />
                ) : (
                  <td className="u-font-bold"> 
                  <a
                    rel="noopener noreferrer"
                    href={`${formatUrl(row.key)}`}
                    target="_blank"
                    className="link"
                  >Contratar</a> </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="u-text-center u-margin-top">
          {props.showMore && (
            <button
              className={`button button--primary ${
                props.isLoadingMore ? 'is-loading' : null
              }`}
              onClick={props.onLoadMore}
            >
              Cargar más
            </button>
          )}
        </div>
      </div>
    ) : (
      <NoBudgetsMessage />
    );
  } else {
    return <div className="centeredSpinner" style={{ maxWidth: 450, height: 450 }} />;
  }
};

export default SentBudgetsTable;



// WEBPACK FOOTER //
// ./src/components/SentBudgets/SentBudgetsTable.js